// Previous and Next for a keyset-paged table. Presentational: the trail that makes Previous
// possible is usePageTrail.js, and a page's `has_more` is what enables Next.

import Icon from './Icon.jsx';

export default function Pager({ busy, hasPrevious, hasMore, onPrevious, onNext }) {
  return (
    <nav className="paging">
      <button type="button" className="icon-button" onClick={onPrevious}
              disabled={busy || !hasPrevious} aria-label="Previous" title="Previous">
        <Icon name="previous" />
      </button>
      <button type="button" className="icon-button" onClick={onNext}
              disabled={busy || !hasMore} aria-label="Next" title="Next">
        <Icon name="next" />
      </button>
    </nav>
  );
}
